import { ResultsMaster } from '../master';
import { TResultsProps } from '../type';
export function ResultsSmirnoff(props: TResultsProps) {
    return <ResultsMaster {...props} />
}